const Roles = {
  Admin: 'Admin',
}

export default Roles;
